import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    padding: theme.spacing(1),
    border: "solid 1px #ccc",
  },
}));

export default function PlayerList(props) {
  const classes = useStyles();

  return <div className={classes.root}>PlayerList</div>;
}
